export const FINE_STATE = {
    PENDING: "Pendiente",
    PAID: "Pagado",
}